import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';

export const featuredPostsSlice = createApi({
  reducerPath: 'featuredPostsApiSlice',
  tagTypes: ['FeaturedPosts'],
  baseQuery,
  endpoints: (builder) => ({
    getFeaturedPosts: builder.query({
      query: ({ apiManager }) => apiManager.get(),
      providesTags: ['FeaturedPosts'],
    }),
    createFeaturedPost: builder.mutation({
      query: ({ apiManager, data }) => apiManager.create(data),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return ['FeaturedPosts'];
      },
    }),
    deleteFeaturedPost: builder.mutation({
      query: ({ apiManager, id }) => apiManager.delete(id),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return ['FeaturedPosts'];
      },
    }),
    updateFeaturedPost: builder.mutation({
      query: ({ apiManager, id, data }) => apiManager.update(id, data),
      invalidatesTags: (_, error) => {
        if (error) {
          return [];
        }

        return ['FeaturedPosts'];
      },
    }),
  }),
});

export const {
  useGetFeaturedPostsQuery,
  useCreateFeaturedPostMutation,
  useDeleteFeaturedPostMutation,
  useUpdateFeaturedPostMutation,
} = featuredPostsSlice;
